import {IssuesCloseOutlined} from '@ant-design/icons';
import {companies, proposalrequest} from '@mep/pae-commons';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {DENOMINATION_TYPES} from '@/modules/proposalRequest/contants/proposalRequest';
import {getUserFullName} from '@/utils/userFullName';

const {COMPANY_STATUS} = companies;
const {CNA, TCP_PROPOSAL, STATE_MIPYME, ORGANIZATION_PMS} = proposalrequest;

export const handleSocialDenomination = (values) => {
  const {socialDenomination, numberOfPartners, status, subjectType, partners, nit, code} = values || {};
  let identifier = socialDenomination;
  
  if (!numberOfPartners || [STATE_MIPYME, ORGANIZATION_PMS].includes(subjectType)) return identifier;
  const isOnePartner = numberOfPartners <= 1;
  
  if ([TCP_PROPOSAL].includes(subjectType)) {
    return socialDenomination || getUserFullName(partners?.[0]) || nit || code;
  }
  
  identifier = identifier?.replace(isOnePartner ? DENOMINATION_TYPES.baseSURL : DENOMINATION_TYPES.baseSRL, '');
  if (identifier.endsWith(isOnePartner ? DENOMINATION_TYPES.SURL : DENOMINATION_TYPES.SRL)) return identifier;
  return `${identifier} ${isOnePartner ? DENOMINATION_TYPES.SURL : DENOMINATION_TYPES.SRL} ${status === COMPANY_STATUS.ON_DISSOLVE_PROCESS ? '(En liquidación)' : ''}`;
};

export const useSocialDenomination = (values = {}) => {
  return handleSocialDenomination(values);
};

export const handleIsSoleOwnerValue = (isSoleOwner, ownerIsSoleOwner) => {
  if (isSoleOwner === undefined || isSoleOwner === null)
    return ownerIsSoleOwner;
  return isSoleOwner;
};

export const useRenderName = (entity, showCode = true) => {
  const {t} = useTranslation('proposalRequest');
  
  const name = useSocialDenomination(entity);
  
  return <div>
    <div>{`${showCode ? `(${entity?.code})` : ''} ${name}`}</div>
    <div>{entity?.commercialization ?
      <div className="text-warning">
        <IssuesCloseOutlined className='pr-1'/>
        {t('proposalRequest.commercialization')}
      </div>
      : null}</div>
  </div>;
};

export const getSocialDenominationSuffix = (type, isSoleOwner) => {
  if (CNA === type) return null;
  return isSoleOwner ? DENOMINATION_TYPES.SURL : DENOMINATION_TYPES.SRL;
};

export const useCodeAndNameRender = (entity, keyValue = 'name', showCode = true) => {
  return `${showCode ? `(${entity?.code})` : ''} ${entity[keyValue]}`;
};
